import EditingStringCell from './EditingStringCell'
import EditingDoubleCell from './EditingDoubleCell'
import EditingDateCell from './EditingDateCell'
import EditingBooleanCell from './EditingBooleanCell'


EditingAttributeCell = ({ dataType, rest... }) ->

  rest.defaultValue ?= ''

  if dataType isnt 'date'
    if _.isObject(rest.defaultValue)
      props = { rest..., defaultValue: '{ object }' }
    else
      props = { rest..., defaultValue: rest.defaultValue }
  else
    props = rest

  switch dataType
    when 'double' then <EditingDoubleCell {props...} />
    when 'date' then <EditingDateCell {props...} />
    when 'boolean' then <EditingBooleanCell {props...} />
    else <EditingStringCell {props...} />

export default React.memo(EditingAttributeCell)